module.exports = __webpack_public_path__ + "static/media/Small-left.1373ef40.svg";